export class AppConfig {
    public readonly JWT_Token = 'BPMIS';
    public readonly Session_User = 'UserData';
    public readonly UPI_NEW_INFO = 'upiDetailsFromLand';
    public readonly UPI_old_INFO = 'upiOldDetailsFromLand';
    public readonly PERMI_ACCESS = 'access'
}
